export default "__VITE_ASSET__d38bcbaf__"